import type { IMultiselectOption } from '~/types'
import { useI18n } from '#imports'

export const useCardFilters = () => {
  const { t } = useI18n()

  const cardType: IMultiselectOption[] = [
    { id: 1, label: t('widget.cards.list_meili_search.filters.card_type.debit'), value: 'debit' },
    { id: 2, label: t('widget.cards.list_meili_search.filters.card_type.credit'), value: 'credit' }
  ]

  const cardCurrencyType: IMultiselectOption[] = [
    {
      id: 1,
      label: t('widget.cards.list_meili_search.filters.currency_type.single'),
      value: 'single'
    },
    {
      id: 2,
      label: t('widget.cards.list_meili_search.filters.currency_type.multi'),
      value: 'multi'
    }
  ]

  const cardBonuses: IMultiselectOption[] = [
    {
      id: 1,
      label: t('widget.cards.list_meili_search.filters.bonuses.option_bonuses'),
      value: 'option_bonuses'
    },
    {
      id: 2,
      label: t('widget.cards.list_meili_search.filters.bonuses.option_cashback'),
      value: 'option_cashback'
    },
    {
      id: 3,
      label: t('widget.cards.list_meili_search.filters.bonuses.interest_rate'),
      value: 'interest_rate'
    }
  ]

  const cardFeatures: IMultiselectOption[] = [
    {
      id: 1,
      label: t('widget.cards.list_meili_search.filters.features.option_loyalty_program'),
      value: 'option_loyalty_program'
    },
    {
      id: 2,
      label: t('widget.cards.list_meili_search.filters.features.option_online_payments'),
      value: 'option_online_payments'
    },
    {
      id: 3,
      label: t('widget.cards.list_meili_search.filters.features.option_wireless_payments'),
      value: 'option_wireless_payments'
    },
    {
      id: 4,
      label: t('widget.cards.list_meili_search.filters.features.option_sms_notifications'),
      value: 'option_sms_notifications'
    },
    {
      id: 5,
      label: t('widget.cards.list_meili_search.filters.features.option_salary_project'),
      value: 'option_salary_project'
    },
    {
      id: 6,
      label: t('widget.cards.list_meili_search.filters.features.option_online_banking'),
      value: 'option_online_banking'
    }
  ]

  return {
    cardType,
    cardCurrencyType,
    cardBonuses,
    cardFeatures
  }
}
